import React from 'react';
import axios from 'axios';
import {Card, Row, Col, Modal, Select as _Select, message, Popover, Icon, Button, Typography} from 'antd';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as etiquetas from '../../ApplicationResources';
import {valueUpperCase, obtenerURL, obtenerURL2, convertArrayToObject, verifiedToken} from '../../utils/funciones.js';
import InputText from '../interfaz/InputText';
import Checkbox from '../interfaz/Checkbox';
import Select from '../interfaz/Select';
import ayudaClaveFUAR from '../../img/Credencial_FUAR.gif';
import {esClaveEoSiap} from '../../utils/funciones.js';
import moment from 'moment';
import Calendario from '../interfaz/Calendario';
import '../../css/registroAspi.css';
import '../../css/modelStyle.css';
import errorImgModal from '../../img/error_icon.svg';
import animacionIneFuar from '../../img/animaciones/animacion_recluta_siap.gif'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { selectDistrito, selectEstado, selectListaEstados, selectListaProcesos, selectProceso, selectListaDistritos } from '../../redux/menu/menu-selectors';
import { selectCurrentUser } from '../../redux/user/user-selectors';
import { obtieneEstados, obtieneProcesosDetalle, obtieneDistritos } from '../../redux/menu/menu-utils';
import { updateDetalle, updateEstado, updateListaEstados, updateListaProcesos,updateListaDistritos } from '../../redux/menu/menu-actions';
import RadioGroup, {Radio} from '../interfaz/Radio';

const { Text } = Typography;
const { Option } = _Select;
const CAP_KEY = "6LexEeIcAAAAAERV_iFUDmdSPi5w-EHHRIQ9RArE"

let msjError = "";
let mostrarCamposExtra = false;

const siNoOptions = [
  { value: 'S', label: 'Sí' },
  { value: 'N', label: 'No' },
];

class DatosCredencial extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            lstProcesos:null,
            idProcesoElectoral : 0,
            idDetalleProceso : 0,
            lstEstados: null,
            lstEstadosDisable: false,
            avisoPrivacidadVisible: false,
            modifica: false,
            infoAspirante : [],
            idEstado : 0,
            seccion : 0,
            nombre : "",
            apellidoP : "",
            apellidoM : "",
            ltsConvocatorias : null,
            puedeRegistrar : true,
            mjs: "",
            modalAbrir: false,
            consultarListaN:null,
            fechaFueraRango:"",
            avanzar : true,
            msjError : "",
            abrirModalError : false,
            sinConvocatoria : "",
            habilitaSeccion: false,
            lstSecciones: null,
            idSede: null,
            ltsSedes : null,
            disabledSedes : true,
            existeEn: 0,
            deshabilitaAviso:true,
            participaOtroDtto: "N",
            habilitaOtroDtto: this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].seccion !== undefined ?  this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].seccion : undefined,
            claveElectorFuar: undefined,
            encuentraOtroCorte: undefined, 
            habilitaSeccionOtro: false,
            encuentraOtroCorteOtroDtto: undefined,
            cuentaCredencial: undefined, 
            disableCuentaCredencial: false
        };
        this.handleBlurClave = this.handleBlurClave.bind(this);
        this.handleObetenerInfoBlur = this.handleObetenerInfoBlur.bind(this);
        this.handleObtenerConvocatorias  = this.handleObtenerConvocatorias.bind(this);
        this.handleVerificarFechaRrgistro = this.handleVerificarFechaRrgistro.bind(this);
        this.handleObtenrIdDtoSeccion = this.handleObtenrIdDtoSeccion.bind(this);
        this.handleCmbConvocatoriaChange = this.handleCmbConvocatoriaChange.bind(this);
        //this.handleConsultarListaNominal();
        this.mostrarCamposExtra();
        if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].seccion !== undefined){
          this.handleConsultaDistrito();
        }
    }

    // Se ejecuta después del renderizado
    componentDidMount = async() =>{
      const {datosUsuario} = this.props;

      

      const tipoUsuario = datosUsuario ? datosUsuario.tipoUsuario : "";

      const idConvocatoria = this.props.getValueComponentWizard('id_convocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
        this.props.getValueComponentWizard('id_convocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      const idSedeReclutamientoJD = this.props.getValueComponentWizard('idSedeReclutamientoJD', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
        this.props.getValueComponentWizard('idSedeReclutamientoJD', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      if(tipoUsuario === "I" && idConvocatoria > 0) {
        const participaOtroDistrito = this.props.getValueComponentWizard('idSedeReclutamientoJD', etiquetas.WIZARD_DATOS_CREDENCIAL)?
        this.props.getValueComponentWizard('participaOtroDttoRadio', etiquetas.WIZARD_DATOS_CREDENCIAL) : undefined
        let event = undefined
        if(participaOtroDistrito)
          event = { target: { value : participaOtroDistrito }}
        // Cargamos la lista de convocatorias solo para el usuario interno
        this.handleObtenerConvocatorias(event);
      }

      if(tipoUsuario === "I" && idSedeReclutamientoJD > 0)
        // Cargamos la lista de sedes de reclutamiento solo para el usuario interno
        this.obtenerSedesReclutamiento();
      
      if(this.props.modifica === true){  // si es modifica entonces desaparece la guia de estatus
        this.setState({ modifica : true, disabledSedes : true});
        this.setState({claveElectorFuar: this.props.getValueComponentWizard('claveElectorFuar', etiquetas.WIZARD_DATOS_CREDENCIAL)})
        this.setState({habilitaOtroDtto:undefined})
        if(this.props.getValueComponentWizard('claveElectorFuar', etiquetas.WIZARD_DATOS_CREDENCIAL).length<18){
          this.setState({cuentaCredencial:'N'})
          this.props.form.setFieldsValue({
            cuentaCredencial:'N'
          })
        }else{
          this.state.disableCuentaCredencial=true
          this.setState({cuentaCredencial:'S', disableCuentaCredencial:true})
          this.props.form.setFieldsValue({
            cuentaCredencial:'S'
          })
        }
        /* Se habilitara el campo de seccion, cuando se identifique que la seccion es de otro corte geografico */
        if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].otroCorte === 1 && this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'] !== undefined ? 
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'N' ? true : false
          : false : false){
          this.props.datosUsuario.tipoUsuario === "I" ? this.setState({habilitaSeccion: true}) : this.setState({habilitaSeccion: false});
          this.handleSecciones();
        }
        

        this.cargaMunicipios();
        this.handleConsultaDistrito(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].seccion);
      }
      
      if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'] !== undefined){
        if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value !== null){
          const distritoParticipando = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value
          let distritoNuevo = '';
          this.props.listaDistritos.some(distrito => {
            if(distrito.idDistrito === distritoParticipando)
              distritoNuevo = distrito.idDistrito + ' - ' + distrito.nombreDistrito;
          });
          this.props.setValueComponentWizard('distritoNuevo', etiquetas.WIZARD_DATOS_CREDENCIAL, distritoNuevo);
        }
      }

      if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'] !== undefined){
        if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value > 0){
         await this.consultarSeccionActual();
        }
      }

    }

    // Se ejecuta antes del primer renderizado
    componentWillMount() {
        // Ejecutamos la carga inicial de estados y procesos
        this.cargaInicialEstadosProcesos();
        // Ejecutamos la carga de escolaridades
        this.cargaInicialEscolaridades();
        // Ejecutamos la carga de medios de difusión
        this.cargaInicialMediosDifusion();
        // Ejecutamos la carga de avisos de privacidad
        this.cargaAvisos();
    }

    /**
    * Función que carga el catálogo de escolaridades
    */
    cargaInicialEscolaridades = () => {
      // Validamos si ya existe información de escolaridades
      if (!this.props.objetos[etiquetas.WIZARD_DATOS_ESCOLARIDAD].lstEscolaridades) {
        // Ejecutamos la función que llama la capacidad para obtener el catálogo de escolaridades
        this.props.getEscolaridades()
          .then(
            lstEscolaridades => { this.props.objetos[etiquetas.WIZARD_DATOS_ESCOLARIDAD].lstEscolaridades = lstEscolaridades }
          )
          .catch(error => {
            console.error("Error al consultar las escolaridades " +
              "componentWillMount()", error);
            if (error.response) {
              if (error.response.status === 409) {
                msjError = error.response.data.message;
              } else if (error.response.data && error.response.data.causa
                && error.response.data.causa.includes("Error de validación")) {
                msjError = error.response.data.message;
              } else {
                msjError = etiquetas.gral_error_cau;
              }
            } else {
              msjError = etiquetas.gral_error_cau;
            }
            this.setState({
              msjError: msjError,
              abrirModalError: true
            });
          });
      }
    }

    /**
    * Función que carga el catálogo de medios de difusión
    */
    cargaInicialMediosDifusion = () => {
      // Validamos si ya existe información de medios de difusión
      if (!this.props.objetos[etiquetas.WIZARD_MEDIO_DIFUSION].lstMediosDifusion) {
        // Ejecutamos la función que llama la capacidad para obtener medios de difusión
        this.props.getMediosDifusionAspirante()
          .then(
            lstMediosDifusion => { this.props.objetos[etiquetas.WIZARD_MEDIO_DIFUSION].lstMediosDifusion = lstMediosDifusion }
          )
          .catch(error => {
            console.error("Error en componentWillMount de MedioConvocatoria", error);
            if (error.response && error.response.status === 409) {
              msjError = error.response.data.message;
            } else {
              msjError = etiquetas.gral_serivicio_no_disponible;
            }
            this.setState({ msjError: msjError, abrirModalError: true });
          });
      }
    }  

    /**
    * Función que carga avisos de Privacidad
    */
    cargaAvisos = () => { 
      let idProcesoElectoral, idDetalleProceso;
      // Validamos de donde obtener la informacón del Proceso Electoral
      if (this.props.proceso !== undefined) {
        //Se obtiene información del proceso desde el selector
        idProcesoElectoral = this.props.proceso.idProcesoElectoral;
        idDetalleProceso = this.props.proceso.idDetalleProceso;
      } else {
        //Se obtiene información del proceso desde el formulario
        idProcesoElectoral = this.props.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL);
        idDetalleProceso = this.props.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL);
      }
      // Ejecutamos la función que llama la capacidad para obtener el catálogo de avisos
      this.props.getAvisos(idProcesoElectoral, idDetalleProceso)
        .then(
          objetoAvisos => { this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].objetoAvisos = objetoAvisos }
        )
        .catch(error => {
          console.error("Error al consultar avisos ", error);
          if (error.response) {
            if (error.response.status === 500) {
              msjError = etiquetas.gral_error_cau;
            }
          }
          this.setState({
            msjError: msjError,
            abrirModalError: true
          });
        });
    }

    /** Función que obtiene la fecha de contratación - parámetro 20 en SUPYCAP.C_FECHAS **/
    obtenerFechaContratacion() {
      // Ejecutamos la función que llama la capacidad para obtener la fecha de contratación
      this.props.getFechaContratacion()
        .then(
          fechaContratacion => { this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES].fechaContratacion = fechaContratacion }
        )
        .catch(error => {
          console.error("Error al consultar la fecha de contratación ", error);
          msjError = etiquetas.gral_error_cau;
          this.setState({
            msjError: msjError,
            abrirModalError: true
          });
        });
    }

    /**
    * Función que carga Municipios
    */
    cargaMunicipios = () => {
      // Ejecutamos la función que llama la capacidad para obtener Municipios
      this.props.getMunicipios()
        .then(
          lstMunicipios => { this.props.objetos[etiquetas.WIZARD_DATOS_DIRECCION].lstMunicipios = lstMunicipios }
        )
        .catch(error => {
          console.error("Error en componentWillMount de Municipios ", error);
          if (error.response && error.response.status === 409) {
            msjError = error.response.data.message;
          } else {
            msjError = etiquetas.gral_serivicio_no_disponible;
          }
          this.setState({ msjError: msjError, abrirModalError: true });
        });
    } 

        /**
    * Función que carga el catálogo de medios de difusión
    */
    cargaInicialMediosDifusion = () => {
      // Validamos si ya existe información de medios de difusión
      if (!this.props.objetos[etiquetas.WIZARD_MEDIO_DIFUSION].lstMediosDifusion) {
        // Ejecutamos la función que llama la capacidad para obtener medios de difusión
        this.props.getMediosDifusionAspirante()
          .then(
            lstMediosDifusion => { this.props.objetos[etiquetas.WIZARD_MEDIO_DIFUSION].lstMediosDifusion = lstMediosDifusion }
          )
          .catch(error => {
            console.error("Error en componentWillMount de MedioConvocatoria", error);
            if (error.response && error.response.status === 409) {
              msjError = error.response.data.message;
            } else {
              msjError = etiquetas.gral_serivicio_no_disponible;
            }
            this.setState({ msjError: msjError, abrirModalError: true });
          });
      }
    } 

    mostrarCamposExtra(){
      if(this.props.datosUsuario !== undefined){
        if ("username" in this.props.datosUsuario) {
          mostrarCamposExtra = true;
        } else {
          mostrarCamposExtra = false;
        }
      } else {
        mostrarCamposExtra = false;
      }
    }

    // Función que limpia el combo de proceso
    limpiarComboProceso = () => {
      // Limpiamos el control Select que tiene el detalleProceso
      this.props.form.setFieldsValue({'idDetalleProceso': undefined});

      // Limpiamos idDetalleProceso y idProcesoElectoral del wizard
      this.props.setValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);
      this.props.setValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      // Limpiamos el estado que contiene idDetalleProceso
      this.setState({idDetalleProceso : 0});

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    // Función que limpia el componente de sección
    limpiarSeccion = () => {
      // Limpiamos el control que contiene la sección
      this.props.form.setFieldsValue({'seccion': undefined});

      // Limpiamos seccion del wizard
      this.props.setValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      // Limpiamos el estado que contiene la sección
      //this.setState({seccion : null});

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    limpiarSedesReclutamiento = () => {
      // Limpiamos el control que contiene la lista de sedes
      this.props.form.setFieldsValue({'idSedeReclutamientoJD': undefined});

      // Limpiamos la lista de sedes del wizard
      this.props.setValueComponentWizard('idSedeReclutamientoJD', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      // Limpiamos el estado que contiene la sede de reclutamiento
      this.setState({idSede:null, ltsSedes: null});

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    // Función que limpia el componente de clave de elector y repetir clave elector
    limpiarClaveElectorFuar = () => {
      // Limpiamos el control que contiene la clave de elector
      this.props.form.setFieldsValue({'claveElectorFuar': undefined});
      this.props.form.setFieldsValue({'claveElectorFuarRepetir': undefined});

      // Limpiamos la clave de elector del wizard
      this.props.setValueComponentWizard('claveElectorFuar', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);
      this.props.setValueComponentWizard('claveElectorFuarRepetir', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    // Función que limpia el componente del check de aviso de privacidad
    limpiarCheckAvisoPrivacidad = () => {
      // Limpiamos el control que contiene el check de aviso de privacidad
      this.props.form.setFieldsValue({'avisoPrivacidad': undefined});

      // Limpiamos el check de aviso de privacidad del wizard
      this.props.setValueComponentWizard('avisoPrivacidad', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    limpiarConvocatorias = () => {
      // Limpiamos el control que contiene las convocatorias
      this.props.form.setFieldsValue({'id_convocatoria' : undefined});

      // Limpiamos el check de aviso de privacidad del wizard
      this.props.setValueComponentWizard('id_convocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      // Limpiamos la lista de convocatorias
      this.setState({ltsConvocatorias : null});

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    limpiarFechaRegistro = () => {
      // Limpiamos el control que contiene la fecha de solicitud
      this.props.form.setFieldsValue({'fechaSolicitud' : undefined});

      // Limpiamos el check de aviso de privacidad del wizard
      this.props.setValueComponentWizard('fechaSolicitud', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    limpiarLocalidades = () => {
      // Limpiamos el control que contiene la fecha de solicitud
      this.props.form.setFieldsValue({'idLocalidad' : undefined});

      // Limpiamos el check de aviso de privacidad del wizard
      this.props.setValueComponentWizard('idLocalidad', etiquetas.WIZARD_DATOS_DIRECCION, undefined);

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    limpiarMunicipios = () => {
      // Limpiamos el control que contiene la fecha de solicitud
      this.props.form.setFieldsValue({'idMunicipio' : undefined});

      // Limpiamos el check de aviso de privacidad del wizard
      this.props.setValueComponentWizard('idMunicipio', etiquetas.WIZARD_DATOS_DIRECCION, undefined);

      // Validamos campos
      this.props.wizard.current.form.validateFields();
    }

    // Función que se ejecuta al seleccionar una entidad del combo
    handleCmbEstado = (value, source) => {
      if(source && source === 'idEstado') {
        // Limpiamos los controles si la acción se ejecuta solamente al presionar el combo idEstado
        this.limpiarComboProceso();
        this.limpiarSeccion();
        this.limpiarSedesReclutamiento();
        this.limpiarClaveElectorFuar();
        this.limpiarCheckAvisoPrivacidad();
        this.limpiarConvocatorias();
        this.limpiarFechaRegistro();
      }

      const {proceso} = this.props;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      // Actualizamos el idEstado del wizard por el que seleccionó el usuario
      this.props.setValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL, value);

      // Llamamos la función que obtiene la lista de procesos
      this.getProcesos(value).then(response => {
        if(response !== null) {
        // Almacenamos temporalmente la lista de procesos para eliminar el primer elemento
        var listaProcesos = response;
        // Se elimina el elemento 0 (TODOS)
        listaProcesos.shift();
        //Se asigna la lista de procesos al wizard de datos de credencial para poderlo usar en otros
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaProcesos = listaProcesos;
        this.setState({
          lstProcesos : listaProcesos,
          idEstado : value,
          idDetalleProceso: 0
        });
        //En regitro externo en caso de que solo exista un proceso electoral en la entidad, se seleccionará automáticamente.
        if (this.props.datosUsuario === null || this.props.datosUsuario === undefined) { //Usuario Externo
          if (this.state.lstProcesos && this.state.lstProcesos.length === 1) {
            this.state.lstProcesos.forEach(proceso => {
              this.setState({
                idProcesoElectoral: proceso.idProcesoElectoral,
                idDetalleProceso: proceso.idDetalleProceso
              });
            });
            this.props.form.setFieldsValue({ 'idDetalleProceso': this.state.idDetalleProceso });
            this.props.setValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL, this.state.idProcesoElectoral);
            this.props.setValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL, this.state.idDetalleProceso);   
          }
        }
        // Obtenemos el idDetalleProceso almacenado en el wizard
        const idDetalleProcesoWizard = this.props.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
              this.props.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
        if(idDetalleProcesoWizard > 0) 
          // Si hay un detalle seleccionado en el wizard
          this.handleCmbDetalleProceso(idDetalleProcesoWizard);
        else if((idDetalleProceso > 0 && idProcesoElectoral > 0))
          // Si hay un detalle seleccionado (usuario interno), se cargan los procesos
          this.handleCmbDetalleProceso(idDetalleProceso);
        }
      });
    }

    // Función que se ejecuta al seleccionar un proceso del combo
    handleCmbDetalleProceso = (value, source) => {
      if(source && source === 'idDetalleProceso') {
        // Limpiamos los controles si la acción se ejecuta solamente al presionar el combo idDetalleProceso
        this.limpiarSeccion();
        this.limpiarSedesReclutamiento();
        this.limpiarClaveElectorFuar();
        this.limpiarCheckAvisoPrivacidad();
        this.limpiarConvocatorias();
        this.limpiarFechaRegistro();
      }

      // Obtenemos el idEstado almacenado en el wizard
      const idEstado = this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                          this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
      // Almacenamos el idDetalleProceso seleccionado por el usuario en el wizard
      this.props.setValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL, value);
      // Almacenamos el idProcesoElectoral (lo tomamos del proceso que selecciona el usuario)
      this.props.setValueComponentWizard('idProcesoElectoral', 
        etiquetas.WIZARD_DATOS_CREDENCIAL, 
      this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados[idEstado].procesos[value].idProcesoElectoral);
      
      // Almacenamos el idCorte del proceso seleccionado
      this.props.setValueComponentWizard("idCorte", 
        etiquetas.WIZARD_DATOS_CREDENCIAL,
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados[idEstado].procesos[value].corte);

      this.setState({idDetalleProceso : value});
      this.props.form.setFieldsValue({ 'idDetalleProceso': value });
      // Para Usuario Externo, ejecutamos la carga avisos de privacidad al seleccionar proceso
      this.cargaAvisos();
      //Obtenemos nombre del proceso cuando se cambia de selección.
      this.obtenerNombreCortoProcesoElectoral();
      this.obtenerNombreLargoProcesoElectoral();
      //this.obtenerFechaContratacion();
      
      // Actualizamos el título del módulo para mostrar el nombre del proceso seleccionado
      this.props.actualizarHeader(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados[idEstado].procesos[value].descripcionDetalleLarga);
    } 

    // Función que obtiene la lista de estados desde el servicio o del wizard si ya hay datos
    getEstados = async () => {
      const {estado, distrito, listaEstados} = this.props;
      // Obtenemos idEstado y idDistrito si se ha seleccionado
      const idEstado = estado ? estado.idEstado : 0;
      const idDistrito = distrito ? distrito.idDistrito : 0;

      if(listaEstados && listaEstados.length > 0) {
        // Actualizamos la lista de estados en el wizard
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados = convertArrayToObject(listaEstados, 'idEstado');
      }
      else if(!this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados) {
        // Actualizamos la lista de estados en el wizard
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados = 
          await obtieneEstados(0, 0, "D", idEstado, idDistrito, 0, "ROL");
      }

      /*if(this.props.proceso != undefined){
        const distritosAspirante = await obtieneDistritos(this.props.proceso.idProcesoElectoral, this.props.proceso.idDetalleProceso, "D", idEstado, 0, 0, "D");
        this.props.updateListaDistritos(this.props.proceso.idDetalleProceso, idEstado, 
          distritosAspirante);
      }*/

      return Object.values(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados);
    }

    // Función que obtiene la lista de distritos desde el servicio o del wizard si ya hay datos
    getDistritos = async () => {
      const {estado,listaDistritos} = this.props;
      // Obtenemos idEstado si se ha seleccionado
      const idEstado = estado ? estado.idEstado : 0;

      if(listaDistritos && listaDistritos.length > 0) {
        // Actualizamos la lista de estados en el wizard
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaDistritos = convertArrayToObject(listaDistritos, 'idDistrito');
      }
      else if(!this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaDistritos) {
        // Actualizamos la lista de estados en el wizard
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaDistritos = 
          await obtieneDistritos(0, 0, "D", idEstado, 0, 0, "ROL");
      }

      return Object.values(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaDistritos);
    }

    getDistrito = async () => {
      const {distrito} = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito : this.props
      const idDistrito = distrito ? distrito.idDistrito:0;
      this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito = idDistrito
      return Object.values(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito);
    }
    
    // Función que obtiene la lista de procesos desde el servicio o del wizard si ya hay datos
    getProcesos = async(idEstadoP) => {
      try {
        const {estado, distrito, listaProcesos} = this.props;
        // Obtenemos idEstado y idDistrito si hay datos de sesión del usuario
        const idEstado = estado ? estado.idEstado : idEstadoP;
        const idDistrito = distrito ? distrito.idDistrito : 0;
  
        if(listaProcesos && listaProcesos.length > 0) {
          // Actualizamos la lista de procesos participantes en el estado seleccionado
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados[idEstado].procesos = 
            convertArrayToObject(listaProcesos, 'idDetalleProceso');
        }
        else if(!this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados[idEstado].procesos) {
          // Actualizamos la lista de procesos participantes en el estado seleccionado
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados[idEstado].procesos = 
            await obtieneProcesosDetalle(idEstado, idDistrito, 0, "F");
        }
  
        return Object.values(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].listaEstados[idEstado].procesos);
      } catch (e) {
        return null;
      }
    }

    // Función que ejecuta la carga inicial de los combos de proceso y entidad
    cargaInicialEstadosProcesos = () => {
      const {estado} = this.props;
      // Obtenemos el idEstado (si es un usuario interno que seleccionó una entidad)
      const idEstado = estado ? estado.idEstado : 0;

      // Obtenemos el idEstado almacenado en el wizard
      const idEstadoWizard = this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
                          this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      // Llamamos la función que obtiene la lista de estados
      this.getEstados().then(response => {
        // Almacenamos temporalmente la lista para eliminar el primer elemento
        var listaEstados = response;
        // Se elimina elemento 0 (TODOS)
        listaEstados.shift();

        // Actualizamos la lista de estados que se usa en el control Select
        this.setState({lstEstados : listaEstados});

        if(idEstadoWizard > 0) {
          this.props.form.setFieldsValue({'idEstado': idEstadoWizard});
          // Llamamos a la función que selecciona y carga los procesos
          this.handleCmbEstado(idEstadoWizard);
        }
        else if(idEstado > 0) {
          // Si hay un estado seleccionado (usuario interno), actualizamos los datos de idEstado
          this.props.setValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL, idEstado);
          this.setState({idEstado: idEstado});
          this.props.form.setFieldsValue({'idEstado': idEstado});
          // Llamamos a la función que selecciona y carga los procesos
          this.handleCmbEstado(idEstado);
        }

      });

      const usuario = this.props.datosUsuario;
      if(usuario !== undefined){
        if(usuario.tipoUsuario === "I"){
          // Llamamos la función que obtiene la lista de distritos
          this.getDistritos().then(response => {
            // Almacenamos temporalmente la lista para eliminar el primer elemento
            var listaDistritos = response;
            // Se elimina elemento 0 (TODOS)
            listaDistritos.shift();

            // Actualizamos la lista de estados que se usa en el control Select
            this.setState({listaDistritos : listaDistritos});

            

          });
        

          //Llamamos función que obtiene el distrito
         // this.getDistrito().then(response => {
           // var idDistrito = response;

           // if(idDistrito > 0){
           //   this.props.setValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL, idDistrito);
           // }
          //})
        }
      }
    }

    // Función que captura el evento del input de sección (usuarios externos)
    handleTxtSeccionRegistroExterno = async(source) =>{
      if(source && source === 'seccion') {
        // Limpiamos los controles si la acción se ejecuta solamente desde el componente seccion
        await this.limpiarSedesReclutamiento();
        await this.limpiarClaveElectorFuar();
        await this.limpiarCheckAvisoPrivacidad();
        await this.limpiarConvocatorias();
        await this.limpiarFechaRegistro();
      }

      if(this.props.objetos[0].seccion.value !== undefined){
        await  this.props.getConvocatoria();
        
        if(this.props.getValueComponentWizard('existeConvocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL)){
          await this.cargaMunicipios();
          await this.consultarSeccionActual();
        }
      }
    }



    handleAvisoPrivacidadClick = (e) => {
        e.preventDefault();
        this.setState({
            avisoPrivacidadVisible : true
        });
    }

    handleAvisoPrivacidadClose = () => {
        this.setState({
            avisoPrivacidadVisible : false
        });
    }

      habilitarCampos = () =>{
        const idEstado = this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
          this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;
          
        if(idEstado > 0) {
          // Si hay un estado seleccionado (usuario interno), actualizamos los datos de idEstado
          this.props.setValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL, idEstado);
          this.setState({idEstado: idEstado});
          this.props.form.setFieldsValue({'idEstado': idEstado});
          // Llamamos a la función que selecciona y carga los procesos
          this.handleCmbEstado(idEstado);
        }else{
          this.setState({
            idEstado : 0,
            seccion : 0
          });
        }
        this.cerrarModal();
        this.setState({modalAbrir: false});
  
        const usuario = this.props.datosUsuario;
  
        if(!this.state.modifica){
          if(usuario && usuario.tipoUsuario === 'I' && usuario.idEstado > 0){
            //se comenta debido a que se cambiaron de orden los campos y no debe realizar este comportamiento
            /*Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL], { 'seccion': {'value': undefined}});
            this.props.form.setFieldsValue({seccion: undefined});*/
          }else{
            if(idEstado===0){
              Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL], { 'idEstado': {'value': undefined},
                                                                                    'seccion': {'value': undefined}});
              this.props.form.setFieldsValue({idEstado: undefined, seccion: undefined});
            }
          }
        }
    }

    /**
    * Abre la ventana modal
    **/
    abrirModal(){
      var modal = document.getElementById("tvesModal");
      var body = document.getElementsByTagName("body")[0];
      modal.style.display = "block";

      body.style.position = "static";
      body.style.height = "100%";
      body.style.overflow = "hidden";
    }

    /**
    * Cierra la ventana modal
    **/
    cerrarModal(event) {
      var modal = document.getElementById("tvesModal");
      var body = document.getElementsByTagName("body")[0];
      modal.style.display = "none";

      body.style.position = "inherit";
      body.style.height = "auto";
      body.style.overflow = "visible";
    }

    cerrarErrorModal(){
      this.setState({abrirModalError:false});
    }

    /**
    * Muestra los mensajes de error
    **/
    mostrarError(error){
      if (error.response){
          if (error.response.status === 409){
              msjError = error.response.data.message;
          } else if (error.response.data && error.response.data.causa
              && error.response.data.causa.includes("Error de validación")){
              msjError = error.response.data.message;
          } else if (error.response && error.response.status === 500){
              msjError = error.response.data.message;
          } else {
              msjError = etiquetas.gral_error_cau;
          }
      } else if(error === 'noSecc'){ 
        msjError = 'La sección no pertenece a algún Distrito'
        }else{
          msjError = etiquetas.gral_error_cau;
        }
      this.setState({
        msjError : msjError,
        abrirModalError : true
      });
    }

    /**
    * Obtiene la lista de las convocatorias vigentes
    * que se muestran en la lista desplegable para JD
    **/
    handleObtenerConvocatorias(event){
      if(this.props.datosUsuario === undefined){
        return;
      }

      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      const seccion = 
      event !== undefined ?
        event.target.value !== 'N' ? 
          this.props.objetos
                [etiquetas.WIZARD_DATOS_CREDENCIAL]['idSeccionDOM'].value !== undefined ?
              this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idSeccionDOM'].value : 0
        :
          this.props.objetos
                [etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value !== undefined ?
              this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value : 0 
      :
          this.props.objetos
          [etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value !== undefined ?
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value : 0 ;

          const idDistrito = 
          event !== undefined ?
        event.target.value !== 'N' ? 
          this.props.objetos
                [etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value !== undefined ?
              this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value : 0
        :
          this.props.objetos
                [etiquetas.WIZARD_DATOS_CREDENCIAL]['idDistrito'] !== undefined ?
              this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idDistrito'] : 0 
      :
          this.props.objetos
          [etiquetas.WIZARD_DATOS_CREDENCIAL]['idDistrito'] !== undefined ?
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idDistrito'] : 0 ;
          /*this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
          this.props.getValueComponentWizard('idParticipacionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
          this.props.getValueComponentWizard('idParticipacionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL):        
          this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;*/

      var postData = {
        "idProcesoElectoral" : idProcesoElectoral,
        "idDetalleProceso" : idDetalleProceso,
        "idEstado" : this.props.objetos
          [etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value !== undefined ?
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value :  0,
        "seccion" : seccion ,
        "idDistrito" : idDistrito
      }

      axios.post(process.env.REACT_APP_API_URL +
        "/ws_reclutaseycae_central/ws/convocatorias", postData,
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem("jwt-token") 
                }
            }
         ).then(response => {
           if(this.props.getValueComponentWizard('idConvocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL)){
            this.handleConvocatoriaChange();
          }else{
            this.props.form.setFieldsValue({
              id_convocatoria : undefined, fechaSolicitud : undefined
            });
          }
           
           var sinConvocatorias = "";
           if(response.data === null || response.data.length === 0){
             sinConvocatorias = etiquetas.gral_no_convo_activa_seccion;

            this.props.form.setFieldsValue({
              id_convocatoria : undefined, fechaSolicitud : undefined, idSedeReclutamientoJD : undefined
            });

            this.setState({
              ltsSedes:null,
              disabledSedes: false
            });

           }
           this.setState({
             sinConvocatoria:sinConvocatorias,
             ltsConvocatorias:response.data
           })
      
           // Se obtienen las sedes de reclutamiento
           this.obtenerSedesReclutamiento();


      }).catch(error => {
        console.error("Error al consultar las convocatorias vigentes "+
            "handleObtenerConvocatorias()",error);
        this.mostrarError(error);
      });
    }


    handleConsultaDistrito(event){
      if(this.props.datosUsuario === undefined){
        return;
      }

      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      var postData = {
        "idProcesoElectoral" : idProcesoElectoral,
        "idDetalleProceso" : idDetalleProceso,
        "idEstado" : this.props.objetos
          [etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value !== undefined ?
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value :  0,
        "seccion" : this.props.objetos
            [etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value !== undefined ?
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value : 0,
      }      

      axios.post(process.env.REACT_APP_API_URL +
        "/ws_reclutaseycae_central/ws/consultarDistrito", postData,
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json', 
                  'Authorization': localStorage.getItem("jwt-token") 
                }
            }
         ).then(response => {
           if(response.data!==''){
            this.setState({
              
              idDistrito:response.data.idDistrito
            })
            if(response.data.corteAnterior && this.state.modifica === false){
              this.setState({encuentraOtroCorte: true});
            }else{
              this.setState({encuentraOtroCorte: false});
            }
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].nombreDttoCredencial = response.data.idDistrito;
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito = response.data.idDistrito;
            this.props.form.setFieldsValue({
              nombreDttoCredencial : response.data.idDistrito + " - " + response.data.nombreDistrito
            })
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].nombreDistrito = response.data.idDistrito + " - " + response.data.nombreDistrito;
            this.props.setValueComponentWizard('nombreDttoCredencial', etiquetas.WIZARD_DATOS_CREDENCIAL, response.data.idDistrito);
            if(response.data === ""){
              console.log('entra al evento de error')
            }
            
            
            this.getDistritos().then(response => {
              // Almacenamos temporalmente la lista para eliminar el primer elemento
              var listaDistritos = response;
              // Se elimina elemento 0 (TODOS)
              listaDistritos.shift();
              listaDistritos = listaDistritos.filter((item) => item.idDistrito !== this.state.idDistrito);
              // Actualizamos la lista de estados que se usa en el control Select
              this.setState({listaDistritos : listaDistritos});
              //this.state.listaDistritos = listaDistritos;
              
      
            });
            
            this.handleObtenerConvocatorias();
        }else{
          this.props.form.setFieldsValue({
            seccion:undefined, nombreDttoCredencial:'', habilitaOtroDtto:"", idSedeReclutamientoJD:undefined,
             id_convocatoria:undefined,ltsConvocatorias:undefined
          });
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito = undefined;
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].ltsConvocatorias = undefined;
          this.state.habilitaOtroDtto=undefined;
          this.mostrarError('noSecc');
          return;
        }
      }).catch(error => {
        console.error("Error al consultar el distrito"+
            "handleConsultaDitstrito()",error);
      });
    }
    /**
     * Función que consulta las sedes de reclutamiento (alternas y fijas)
     */
    obtenerSedesReclutamiento(){
      const idProcesoElectoral = this.props.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
              this.props.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      const idDetalleProceso = this.props.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
        this.props.getValueComponentWizard('idDetalleProceso', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      const idEstado = this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
        this.props.getValueComponentWizard('idEstado', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      const seccion = this.props.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
              this.props.getValueComponentWizard('idSeccionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL) ? 
              this.props.getValueComponentWizard('idSeccionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL) :
              this.props.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      const idDistrito = this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
      this.props.getValueComponentWizard('idParticipacionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
      this.props.getValueComponentWizard('idParticipacionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL):        
      this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      var postData = {
        "idProcesoElectoral" : idProcesoElectoral,
        "idDetalleProceso" : idDetalleProceso,
        "idEstado" : idEstado,
        "seccion" : seccion,
        "idDistrito" :idDistrito
      }

      axios.post(process.env.REACT_APP_API_URL +
  			"/ws_reclutaseycae_central/ws/obtenerSedesReclutamiento", postData,
  					{
  							headers: {
  								'Accept': 'application/json',
  								'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem("jwt-token") 
  							}
  					}
  			 ).then(response => {
          this.setState({
            ltsSedes : JSON.parse(JSON.stringify(response.data))
          });

          if(this.state.ltsSedes && this.state.ltsSedes.length === 1) {
            // Deshabilito el combo de sedes de reclutamiento
            this.setState({
              disabledSedes : true
            });

            this.state.ltsSedes.forEach(valor => {
              this.setState({
                idSede : valor.id
              });
            });

            this.props.form.setFieldsValue({idSedeReclutamientoJD: this.state.idSede});
          } else {
            if(this.props.modifica === true){
              this.setState({
                disabledSedes : true
              });
            } else {
              this.setState({
                disabledSedes : false
              });
            }
          }

          
          this.props.wizard.current.form.validateFields();
      }).catch(error => {
            console.error("Error al consultar las sedes de reclutamiento disponibles"+
            "handleObtenrIdDtoSeccion()",error);
        this.mostrarError(error);
      });
    }

    handleConvocatoriaChange= (value, event) => {
      this.props.getConvocatorias()
        .then(ltsConvocatorias => this.setState({ ltsConvocatorias: ltsConvocatorias }))
        .catch(error => {
          console.error("Error al cargar las convocatorias",error);
            if (error.response && error.response.status === 409){
                msjError = error.response.data.message;
            } else {
                msjError = etiquetas.gral_serivicio_no_disponible;
            }

            this.setState({
              msjError : msjError,
              abrirModalError : true
            });
        });
    }
    handleConvocatoriaChange2= (value, event) => {
      this.setState({dttoTemp:this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito});
      this.setState({dttoNameTemp:this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].nombreDistrito})
      this.props.getConvocatorias()
        .then(ltsConvocatorias => this.setState({ ltsConvocatorias: value }))
        .catch(error => {
          console.error("Error al cargar las convocatorias",error);
            if (error.response && error.response.status === 409){
                msjError = error.response.data.message;
            } else {
                msjError = etiquetas.gral_serivicio_no_disponible;
            }

            this.setState({
              msjError : msjError,
              abrirModalError : true
            });
        });
      this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito = this.state.dttoTemp;
      this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].nombreDistrito = this.state.dttoNameTemp;
    }

    /**
    * Revisa si la clave que se ingreso es SIAP o clave de elector.
    * 1.- clave de elector 2.- SIAP
    **/
    handleBlurClave = (value, source) => {
      var claveFuar = this.props.form.getFieldValue('claveElectorFuar');
      var claveFuarRepetir = this.props.form.getFieldValue('claveElectorFuarRepetir');

      if(claveFuar === undefined || claveFuarRepetir === undefined)
        return;

      if(claveFuar === "" || claveFuarRepetir === "")
        return;

      if(claveFuar !== claveFuarRepetir) {
        this.setState({mjs: 'Las claves no coinciden.'});
        this.setState({modalAbrir:true});

        if(source === 'claveElectorFuar') {
          Object.assign(
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL],
            { 'claveElectorFuar': undefined});
            this.props.form.setFieldsValue({claveElectorFuar: undefined});
        }

        if(source === 'claveElectorFuarRepetir') {
          Object.assign(
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL],
            { 'claveElectorFuarRepetir': undefined});
            this.props.form.setFieldsValue({claveElectorFuarRepetir: undefined});
        }
        this.props.wizard.current.form.validateFields();
        /*this.props.form.setFieldsValue({
          id_convocatoria : undefined, fechaSolicitud : undefined
        });

        this.setState({ltsConvocatorias:null});*/
      } else {
        var claveEoSiap = 0;
        /*this.setState({
         idEstado : 0,
         seccion : 0
        });*/
  
        claveEoSiap = esClaveEoSiap(claveFuar);
  
        if (claveEoSiap === 1 && this.state.consultarListaN === 1) {
          this.obtenerDatosAspirante(claveFuar);
        }else{
          if(this.props.modifica === true) {
            // Expresión regular para la clave de elector
            const regex = new RegExp(etiquetas.REGEX_FORMATO_CLAVE_ELECTOR)
            // Se valida que la actualización sea de FUAR u OCR a clave de elector
            if(this.state.claveElectorFuar !== this.props.form.getFieldValue('claveElectorFuar') && regex.test(this.props.form.getFieldValue('claveElectorFuar'))) {
              this.setState({puedeRegistrar:true});
              var datosAspirante = {};
                datosAspirante.numeroElector = this.props.form.getFieldValue('claveElectorFuar');
              this.confirmarRegistro(datosAspirante);
            } else if(this.state.claveElectorFuar !== this.props.form.getFieldValue('claveElectorFuar')) {
              this.props.form.setFieldsValue({claveElectorFuar: this.state.claveElectorFuar});
              this.props.form.setFieldsValue({claveElectorFuarRepetir: this.state.claveElectorFuar});
              claveEoSiap = esClaveEoSiap(this.state.claveElectorFuar)
              this.setState({mjs: 'El SIAP (antes FUAR), solo puede ser actualizada por una Clave de Elector válida.'});
              this.setState({modalAbrir:true}); 
            }
          } else {
            this.setState({puedeRegistrar:true});
            var datosAspirante = {};
              datosAspirante.numeroElector = this.props.form.getFieldValue('claveElectorFuar');
            this.confirmarRegistro(datosAspirante);
          }
        }
  
        Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL  ], {
            'datosPersonales': {'value': claveEoSiap}
        });
  
          this.mostrarCampoEdo();
          this.setState({ deshabilitaAviso: false });
      }
    }

    /*
    * valida que la entidad del usuario de JD coincida con la de
    * la clave de elector para poder registrarlo o no.
    * 87. naturalizados
    * 88. doble nacionalidad.
    */
    validarEntidad(datosAspirante){
      if (this.props.datosUsuario === undefined) {
        return true;
      }

      this.props.wizard.current.cambiaNegocio('seccion', false);
      var puedeRegistrar = false;

      var entidadAsp = datosAspirante.idEstado;
      var distritoAsp = datosAspirante.idDistrito;
      var entidadUsrJd = this.props.datosUsuario.idEstado;
      var distritoUsrJd = this.props.datosUsuario.idDistrito;

      if (entidadUsrJd === 0 || (entidadUsrJd === entidadAsp &&
                                               distritoUsrJd === distritoAsp)) {
        puedeRegistrar = true;
        this.props.wizard.current.cambiaNegocio('seccion', true);
      }
      this.setState({puedeRegistrar:puedeRegistrar,avanzar:puedeRegistrar});

      return puedeRegistrar;
    }

    /**
    * truco para refrescar y se pudiera tomar el valor.
    **/
    mostrarCampoEdo(){
      this.setState({
        infoAspirante:null
      });
    }

    /**
    * Obtiene la información personal de la lista nominal
    * mediante la clave de elctor
    **/
    obtenerDatosAspirante(claveFuar){
      var postData = {
  			claveElector : claveFuar
  		}
      axios.post(process.env.REACT_APP_API_URL +
  			"/ws_reclutaseycae_central/ws/detalleAspirantes", postData,
  					{
  							headers: {
  								'Accept': 'application/json',
  								'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem("jwt-token") 
  							}
  					}
  			 ).then(response => {
           this.setState({
             infoAspirante:response.data.resultadoRepre
           })
           if(response.data.resultadoRepre !== null){
             if(this.validarEntidad(response.data.resultadoRepre)){
                 this.acomodarDatosAspirante(response.data.resultadoRepre);
             }else{
               msjError = "La clave de elector ingresada no pertenece a "+
                                       "tu distrito, intenta nuevamente.";
               this.setState({
                 msjError : msjError,
                 abrirModalError : true
               });
             }
           }else{
               var datosAspirante = {};
               this.setState({puedeRegistrar:true});
               datosAspirante.numeroElector =
                              this.props.form.getFieldValue('claveElectorFuar');
               this.confirmarRegistro(datosAspirante);
           }
      }).catch(error => {
          console.error("Error al consultar clave en LN "+
              "obtenerDatosAspirante()",error);
          this.mostrarError(error);
      });
    }

    /**
    * Acomoda la información obtenida de la lista nominal
    **/
    acomodarDatosAspirante(datosAspirante){
      if(datosAspirante !== null){
        this.setState({
         idEstado : datosAspirante.idEstado,
         seccion : datosAspirante.seccion,
         nombre : datosAspirante.nombre,
         apellidoP : datosAspirante.apellidoPaterno,
         apellidoM : datosAspirante.apellidoMaterno
       });
       Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL], {
            'idEstado': {'value': this.state.idEstado},
            'seccion': {'value': this.state.seccion}
       });
       this.props.form.setFieldsValue({idEstado:this.state.idEstado,seccion:this.state.seccion});

       this.confirmarRegistro(datosAspirante);

       this.handleObtenerConvocatorias();

     }else{
         this.setState({
          idEstado : 0,
          seccion : 0,
          nombre : "",
          apellidoP : "",
          apellidoM : ""
        });
         Object.assign(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL], {
             'datosPersonales': {'value': 2}
         });
     }
     this.props.getConvocatoria(1);

    }

    /** Verifica si la clave de elector se encuentra en base de datos**/
    confirmarRegistro(datosAspirante) {
      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

      let hd = { 'Accept': 'application/json'
                    ,'Content-Type': 'application/json'};

      hd = verifiedToken(hd);

        axios.post(process.env.REACT_APP_API_URL +
                                 '/ws_reclutaseycae_central/ws/confirmarRegistro', {
            claveElector: datosAspirante.numeroElector,
            idProceso : idProcesoElectoral,
            idDetalle : idDetalleProceso,
        },{
            headers: hd
        }).then(response => {
            if(response.data.length > 0){
                var artClave = " ";
                var esClaveElectorFuar = etiquetas.REGEX_FORMATO_SOLO_DIGITOS.test(datosAspirante.numeroElector);
                if(esClaveElectorFuar){
                  artClave = this.props.datosUsuario === undefined ?'Tu SIAP: ' : 'El SIAP: ';
                }else{
                  artClave = this.props.datosUsuario === undefined ? 'Tu clave de elector: ' : 'La clave de elector: ';
                }
                var elLos = response.data.length > 1 ? 'los':'el';
                var ttoS = response.data.length > 1 ? 'distritos':'distrito';
                var msjArmado = " ";
                msjArmado += artClave +  response.data[0].claveElectorFuar + ' \n Se registró en la entidad de '
                + response.data[0].nombreEstado + ' en '+elLos+ ' ' +ttoS+' de: \n';
                Object.keys(response.data).map((item) =>{
                   msjArmado +=  response.data[item].idDistrito +'- ' + response.data[item].cabeceraDistrital + ' en la convocatoria '+ 
                   response.data[item].numeroConvocatoria + '(' +response.data[item].fechaRegistroInicio+' a '+response.data[item].fechaRegistroFin+ ') \n ';
                  
                  const participaOtroDistrito = this.props.getValueComponentWizard('participaOtroDttoRadio', etiquetas.WIZARD_DATOS_CREDENCIAL)
                  const idConvocatoria = this.props.getValueComponentWizard('idConvocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL)
                  
                  if(participaOtroDistrito && participaOtroDistrito === 'S') {
                    const idDistritoParticipacion = this.props.getValueComponentWizard('idParticipacionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL)

                    if(response.data[item].idDistrito === idDistritoParticipacion
                      && response.data[item].idConvocatoria === idConvocatoria){
                      this.setState({existeEn: 1})
                    }
                  } else {
                    if(response.data[item].idDistrito === this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito
                      && response.data[item].idConvocatoria === idConvocatoria){
                      this.setState({existeEn: 1})
                    }
                  }
                });
                if(this.state.existeEn === 1){
                  Object.assign(
                    this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL],
                    { 'claveElectorFuar': {value:undefined}},
                       );
                       this.props.wizard.current.callbackResponse({0: {claveElectorFuar: {
                        error: this.props.datosUsuario !== undefined ?  this.state.cuentaCredencial === 'S' ? etiquetas.gral_clave_en_convocatoria_seleccionada : etiquetas.gral_siap_en_convocatoria_seleccionada : this.state.cuentaCredencial === 'S' ? etiquetas.gral_clave_en_convocatoria : etiquetas.gral_siap_en_convocatoria
                      }}});
                  Object.assign(
                    this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL],
                    { 'claveElectorFuarRepetir': undefined});
                    this.props.form.setFieldsValue({claveElectorFuarRepetir: undefined});
                    this.setState({existeEn: 0})
                    this.setState({
                      msjError : this.props.datosUsuario !== undefined ?  this.state.cuentaCredencial === 'S' ? etiquetas.gral_clave_en_convocatoria_seleccionada : etiquetas.gral_siap_en_convocatoria_seleccionada : this.state.cuentaCredencial === 'S' ? etiquetas.gral_clave_en_convocatoria : etiquetas.gral_siap_en_convocatoria,
                      abrirModalError : true
                      });
                }else{
                  this.setState({mjs: msjArmado});
                  this.setState({modalAbrir:true});
                }
                


                /*Object.assign(
                  this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL],
                  { 'claveElectorFuar': {'value': ""}, 'claveElectorFuarRepetir': {'value': ""}});
                this.props.form.setFieldsValue({claveElectorFuar: ""});
                this.props.form.setFieldsValue({claveElectorFuarRepetir: ""});*/
            }else {
                if(this.state.infoAspirante !== null){
                    this.abrirModal();
                }
            }
        }).catch(error => {
          console.error("Error al verificar que ya exista en aspirantes  "+
                "la clave de elector. confirmarRegistro()",error);
          this.mostrarError(error);
        });
    }

    /**
    * Obtiene el idProceso, detalle
    **/
    handleObetenerInfoBlur(event){
      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

      var postData = {
        "idProcesoElectoral" : idProcesoElectoral,
        "idDetalleProceso" : idDetalleProceso,
        "idEstado" : this.props.objetos
            [etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value !== undefined ?
            this.props.objetos
                      [etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value : 0,
        "seccion" :  this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'S' ? 
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idSeccionDOM'].value : this.props.objetos
                    [etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value,
        "idConvocatoria" : this.props.objetos
            [etiquetas.WIZARD_DATOS_CREDENCIAL]['id_convocatoria'].value !== undefined ?
            this.props.objetos
                        [etiquetas.WIZARD_DATOS_CREDENCIAL]['id_convocatoria'].value : 0,
        "esJuntaDistrital": this.props.datosUsuario !== undefined ? true : false
      }

      // Obtenido los datos del servidor
      let hd = { 'Accept': 'application/json'
        ,'Content-Type': 'application/json'};

      hd = verifiedToken(hd);
      axios.post(process.env.REACT_APP_API_URL +
        '/ws_reclutaseycae_central/ws/convocatoria', postData,
        {
              headers: hd
          }
      ).then(response => {
          if(response.data !== ""){
            let idDistritoAntes = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito;
              Object.assign(this.props.objetos
                          [etiquetas.WIZARD_DATOS_CREDENCIAL], response.data);
                          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito = idDistritoAntes;
              this.props.wizard.current.cambiaNegocio('seccion', true);
              this.handleVerificarFechaRrgistro();
          } else {
            this.setState({fechaFueraRango: etiquetas.gral_error_fecha_fuera_rango});
            this.props.form.setFieldsValue({
              id_convocatoria : undefined,
              fechaSolicitud : undefined
            });
          }
      }).catch(error => {
            console.error("Error al consultar la información de la "+
                "convocatoria en handleObetenerInfoBlur()",error);
          this.mostrarError(error);
      });

    }

    /*
    * Obtiene el valor del parametro 35 de la tablas c_parametros
    * el cual indicará si podemos ontener la información del Aspirante
    * de la lista nominal o no.
    */
    handleConsultarListaNominal(){
      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

      var postData = {
        idProcesoElectoral : idProcesoElectoral,
        idDetalleProcesoElectoral : idDetalleProceso,
        idParametro : 35
      }
      axios.post(process.env.REACT_APP_API_URL +
  			"/ws_reclutaseycae_central/ws/consultarListaN", postData,
  					{
  							headers: {
  								'Accept': 'application/json',
  								'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem("jwt-token") 
  							}
  					}
  			 ).then(response => {
           this.setState({
               consultarListaN : response.data.valorParametro
           })
      }).catch(error => {
            console.error("Error al consultar el parametro 35 en "+
                          "handleConsultarListaNominal()",error);
          this.mostrarError(error);
      });
    }

    /*
    * Valida que la fecha registrada para registro se encuentre dentro
    * del rango de la convocatoria.
    */
    handleVerificarFechaRrgistro(event){
      var error = "";
      if(this.state.ltsConvocatorias !== null){
        var idConvocatoria = this.props.form.getFieldValue("id_convocatoria");
        var fechaRegistro = new Date(
            this.props.form.getFieldValue("fechaSolicitud").format("YYYY-MM-DD"));
        var fechaInicio;
        var fechaFin;
        console.info("valores",idConvocatoria,fechaRegistro);
        console.info("ltsConvocatorias ",this.state.ltsConvocatorias.length);
        for(var i=0; i < this.state.ltsConvocatorias.length;i++){
          if(this.state.ltsConvocatorias[i].idConvocatoria === idConvocatoria){
            fechaInicio = new Date(this.state.ltsConvocatorias[i].fechaRegistroInicio);
            fechaFin = new Date(this.state.ltsConvocatorias[i].fechaRegistroFin);
          }
        }
        // se setean las hrs, min, s, ms para que solo se comparen las fechas.
        fechaRegistro.setHours(0,0,0,0);
        fechaInicio.setHours(0,0,0,0);
        fechaFin.setHours(0,0,0,0);

        if(fechaRegistro >= fechaInicio && fechaRegistro <= fechaFin){
          console.info("se puede registrar");
          this.props.wizard.current.cambiaNegocio('seccion', true);
        } else {
          console.info("La fecha de regsitro está fuera de rango-DatosCredencial.js");
          this.props.wizard.current.cambiaNegocio('seccion', false);
          error = etiquetas.gral_error_fecha_fuera_rango;
        }
        if(this.state.avanzar === false){
          this.props.wizard.current.cambiaNegocio('seccion', false);
        }


      }else{
        console.info("la lista de convocatorias está vacia",
                                                   this.state.ltsConvocatorias);
         this.props.form.setFieldsValue({
           seccion : undefined,
           id_convocatoria : undefined,
           fechaSolicitud : undefined
         });
         error = etiquetas.gral_error_fecha_fuera_rango;
      }

      this.setState({fechaFueraRango: error});
    }

    /*
    *Evento para usuarios internos
    */
    handleObtenrIdDtoSeccion = (event,value) =>{
      
      this.props.form.setFieldsValue({
        id_convocatoria : undefined,
        fechaSolicitud : undefined
      });
      this.props.setValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);

      this.setState({
        ltsConvocatorias : null,
        habilitaOtroDtto:this.props.form.getFieldValue('seccion')
      });

      if (this.props.datosUsuario === undefined) {
        return true;
      }

      // Se limpian los campos
      this.props.form.setFieldsValue({
        id_convocatoria : undefined, fechaSolicitud : undefined, idSedeReclutamientoJD : undefined,
        nombreDttoCredencial: this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idDistrito,participaOtroDttoRadio: undefined,
        idParticipacionDOM : undefined, idSeccionDOM: undefined
      });

      
      this.props.setValueComponentWizard('participaOtroDttoRadio',etiquetas.WIZARD_DATOS_CREDENCIAL,'N');

      
      this.props.wizard.current.form.validateFields();
      if(this.props.objetos[0].seccion.value !== undefined){
        
        this.handleConsultaDistrito();
        
        this.cargaMunicipios();
        
      }
      this.obtenerNombreCortoProcesoElectoral();
      this.obtenerNombreLargoProcesoElectoral();
    }

    verificarDistritoAspUsr(distritoAsp){
      this.props.wizard.current.cambiaNegocio('seccion', false);
      var puedeRegistrar = false;
      var claveFuar = this.props.form.getFieldValue("claveElectorFuar");

      if(claveFuar === undefined || claveFuar === ''){
        this.setState({avanzar:puedeRegistrar});
        return puedeRegistrar;
      }
      var claveEoSiap = esClaveEoSiap(claveFuar);

      if (claveEoSiap === 1) {
        var entidadAsp = this.props.form.getFieldValue("idEstado") !== undefined
                                ? this.props.form.getFieldValue("idEstado") : 0;
        var entidadUsrJd = this.props.datosUsuario.idEstado;
        var distritoUsrJd = this.props.datosUsuario.idDistrito;
        console.info("valores para validar su puede registar la clave",
                  entidadUsrJd , entidadAsp ,distritoUsrJd , distritoAsp);

        if((entidadUsrJd === 0 && distritoUsrJd === 0) ||
            (entidadUsrJd > 0 && distritoUsrJd === 0)){
              return true
        }
        if((entidadUsrJd === entidadAsp && distritoUsrJd === distritoAsp)) {
          puedeRegistrar = true;
          this.props.wizard.current.cambiaNegocio('seccion', true);
        }else {
          this.props.form.setFieldsValue({'seccion': undefined,
                                                   'claveElectorFuar':undefined});
        }
      }else{
        puedeRegistrar = true;
      }
      this.setState({avanzar:puedeRegistrar});
      return puedeRegistrar;
    }

    handleSecciones(){
      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

      var postData = {
        "idProcesoElectoral" : idProcesoElectoral,
        "idDetalleProceso": idDetalleProceso,
        "idParticipacion": this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idParticipacion,
        "idEstado" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value,
        "idDistrito" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value
      }

      const jwt = localStorage.getItem('jwt-token');
      axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/secciones', postData,
      {
        headers: { 'Accept': 'application/json'
                  ,'Content-Type': 'application/json'
                  ,'Authorization': jwt
        }
      }).then(response => {
        if(response.data.length !== null || response.data.length !== 0){
          this.setState({lstSecciones: response.data
          });
          
        }
      }).catch(error => {
        console.error("Error al consultar las secciones. handleSecciones()",error);
        this.mostrarError(error);
      });
      
    }

    onChangeListaSecciones = () => {
      if(this.props.getValueComponentWizard('seccion', etiquetas.WIZARD_DATOS_CREDENCIAL) !== undefined){
        // Si el usuario selecciona una sección de la lista, significa que quiere actualizar a la sección del 
        // corte actual (ya que el aspirante se registró con una sección de otro corte geográfico)

        // Se limpia el campo de localidades
        this.limpiarLocalidades();
        // Se limpia el campo de municipios
        this.limpiarMunicipios();
        // Cargamos la lista de municipios de la nueva sección seleccionada
        this.cargaMunicipios();
        // Se limpia la lista de localidades
        this.props.setValueComponentWizard('lstLocalidades', etiquetas.WIZARD_DATOS_DIRECCION, undefined);
        // Se actualiza el campo otro corte debido a que se seleccionó una sección del corte actual
        this.props.setValueComponentWizard('otroCorte', etiquetas.WIZARD_DATOS_CREDENCIAL, 0);
      }
    }

    onChangeDistritoParticipa = () =>{
      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

      var postData = {
        "idProcesoElectoral" : idProcesoElectoral,
        "idDetalleProceso": idDetalleProceso,
        "idParticipacion": this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].idParticipacion,
        "idEstado" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value,
        "idDistrito" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value
      }

      const jwt = localStorage.getItem('jwt-token');
      axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/secciones', postData,
      {
        headers: { 'Accept': 'application/json'
                  ,'Content-Type': 'application/json'
                  ,'Authorization': jwt
        }
      }).then(response => {
        if(response.data.length !== null || response.data.length !== 0){
          this.setState({lstSecciones: response.data,
          idSeccionDOM:undefined});
        }
        const distritoParticipando = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value
        let distritoNuevo = '';
        this.state.listaDistritos.some(distrito => {
          if(distrito.idDistrito === distritoParticipando)
            distritoNuevo = distrito.idDistrito + ' - ' + distrito.nombreDistrito;
        });

        this.props.form.setFieldsValue({
          idSeccionDOM : undefined, fechaSolicitud : undefined, idSedeReclutamientoJD : undefined, ltsSedes:undefined
        });
        this.props.setValueComponentWizard('distritoNuevo', etiquetas.WIZARD_DATOS_CREDENCIAL, distritoNuevo);
        this.props.setValueComponentWizard('idSeccionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);
        
      }).catch(error => {
        console.error("Error al consultar las secciones. onChangeDistritoParticipa()",error);
        this.mostrarError(error);
      });
    }

    handleCmbConvocatoriaChange (event) {
      // Se limpian los campos
      this.props.form.setFieldsValue({
        fechaSolicitud : undefined
      });

      this.props.wizard.current.form.validateFields();

      this.props.getValidaConvocatoria(event);
    }

    obtenerNombreCortoProcesoElectoral() {
      var idProcesoElectoral = this.props.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL);
      // Ejecutamos la función que llama la capacidad para obtener el nombre corto del Proceso Electoral
      this.props.obtenerEtiquetaNombreProceso(idProcesoElectoral, etiquetas.ID_ETIQUETA_NOMBRE_CORTO_PROCESO)
        .then(
          response => {
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].nombreCortoProceso = response != null ? response : "proceso";
          }).catch(error => {
            console.error("Error al consultar etiqueta del nombre corto del Proceso Electoral", error);
            if (error.response) {
              if (error.response.status === 500) {
                msjError = etiquetas.gral_error_cau;
              }
            }
            this.setState({
              msjError: msjError,
              abrirModalError: true
            });
          });
    }

    obtenerNombreLargoProcesoElectoral() {
      var idProcesoElectoral = this.props.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL);
      // Ejecutamos la función que llama la capacidad para obtener el nombre largo del Proceso Electoral
      this.props.obtenerEtiquetaNombreProceso(idProcesoElectoral, etiquetas.ID_ETIQUETA_NOMBRE_LARGO_PROCESO)
        .then(
          response => {
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].nombreProceso = response != null ? response : "proceso";
          }).catch(error => {
            console.error("Error al consultar etiqueta del nombre largo del Proceso Electoral", error);
            if (error.response) {
              if (error.response.status === 500) {
                msjError = etiquetas.gral_error_cau;
              }
            }
            this.setState({
              msjError: msjError,
              abrirModalError: true
            });
          });
    }

    handlerManejadorSN = (event) =>{
      
      if(event.target.value === 'S'){
        this.props.form.setFieldsValue({
          id_convocatoria : undefined, fechaSolicitud : undefined, idSedeReclutamientoJD : undefined
        });
        this.setState({
          ltsSedes:undefined,
          ltsConvocatorias:undefined
        });
        this.props.setValueComponentWizard('idConvocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL, undefined);
      }else{
        this.props.form.setFieldsValue({
          idSeccionDOM : undefined, idSedeReclutamientoJD:undefined, idConvocatoria:undefined, idParticipacionDOM:undefined
        });
        this.handleObtenerConvocatorias(event);
      }
    }

    handlerManejadorSNCredencial = (event) =>{
        this.props.form.setFieldsValue({
          claveElectorFuar: '',
          claveElectorFuarRepetir: '',
          
        })
        this.setState({
          cuentaCredencial: event.target.value
        })
        this.props.wizard.current.form.validateFields();
    }


    handleObtenerConvocatoriasNueva(event){
      if(this.props.datosUsuario === undefined){
        return;
      }

      const { proceso } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      const idDistrito = this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
          this.props.getValueComponentWizard('idParticipacionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL) ?
          this.props.getValueComponentWizard('idParticipacionDOM', etiquetas.WIZARD_DATOS_CREDENCIAL):        
          this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL) : 0;

      var postData = {
        "idProcesoElectoral" : idProcesoElectoral,
        "idDetalleProceso" : idDetalleProceso,
        "idEstado" : this.props.objetos
          [etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value !== undefined ?
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value :  0,
        "seccion" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idSeccionDOM'].value ,
        "idDistrito" : idDistrito
      }

      axios.post(process.env.REACT_APP_API_URL +
        "/ws_reclutaseycae_central/ws/convocatorias", postData,
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem("jwt-token") 
                }
            }
         ).then(response => {
           if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idConvocatoria'] !== undefined){
            this.handleConvocatoriaChange2(response.data);
          }else{
            this.props.form.setFieldsValue({
              id_convocatoria : undefined, fechaSolicitud : undefined
            });
          }
           
           var sinConvocatorias = "";
           if(response.data === null || response.data.length === 0){
             sinConvocatorias = etiquetas.gral_no_convo_activa_seccion;

            this.props.form.setFieldsValue({
              id_convocatoria : undefined, fechaSolicitud : undefined, idSedeReclutamientoJD : undefined
            });

            this.setState({
              ltsSedes:null,
              disabledSedes: false
            });

           }
           this.setState({
             sinConvocatoria:sinConvocatorias,
             ltsConvocatorias:response.data
           })
           this.state.ltsConvocatorias = response.data;
           // Se obtienen las sedes de reclutamiento
           this.obtenerSedesReclutamiento();


      }).catch(error => {
        console.error("Error al consultar las convocatorias vigentes "+
            "handleObtenerConvocatorias()",error);
        this.mostrarError(error);
      });
    }

    consultarSeccionActual = async  () =>{
      const json = {
        "idProcesoElectoral" : this.props.objetos
        [etiquetas.WIZARD_DATOS_CREDENCIAL]['idProcesoElectoral'] !== undefined ?
        this.props.getValueComponentWizard('idProcesoElectoral', etiquetas.WIZARD_DATOS_CREDENCIAL) :  0,
        "idDetalleProceso" : this.props.objetos
        [etiquetas.WIZARD_DATOS_CREDENCIAL]['idDetalleProceso'].value !== undefined ?
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idDetalleProceso'].value :  0,
        "idEstado" : this.props.objetos
          [etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value !== undefined ?
          this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value :  0,
        "seccion" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'] !== undefined ? 
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'S' ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idSeccionDOM'].value : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value
        : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['seccion'].value,
        "idDistrito" : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'] !== undefined ? 
        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'S' ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idParticipacionDOM'].value : this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL)
        : this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL) : this.props.getValueComponentWizard('idDistrito', etiquetas.WIZARD_DATOS_CREDENCIAL),
        "idConvocatoria" : this.props.objetos
        [etiquetas.WIZARD_DATOS_CREDENCIAL]['idConvocatoria'] !== undefined ?
        this.props.getValueComponentWizard('idConvocatoria', etiquetas.WIZARD_DATOS_CREDENCIAL) :  0
      }

      let hd = { 'Accept': 'application/json'
        ,'Content-Type': 'application/json'};

      hd = verifiedToken(hd);     
      let response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/consultar_corte'
          , json
          , {
              headers: hd
          }
      )
      
      if(response.data !== undefined){
        
        if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'] !== undefined ){
          if(this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'S'){
            this.setState({encuentraOtroCorteOtroDtto: response.data.data})
            this.setState({encuentraOtroCorte: false})
          }else{
            this.setState({encuentraOtroCorte: response.data.data})
            this.setState({encuentraOtroCorteOtroDtto: false})
          }
          
        } 
          
        
        if((response.data.data === true) && (this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.getValueComponentWizard('participaOtroDttoRadio', etiquetas.WIZARD_DATOS_CREDENCIAL) === 'S' ? true : false : false ) && this.props.modifica === true){
            this.props.datosUsuario.tipoUsuario === "I" ? this.setState({habilitaSeccionOtro: true}) : this.setState({habilitaSeccionOtro: false});
            this.handleSecciones();
          }
          if((response.data.data === true) && (this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.getValueComponentWizard('participaOtroDttoRadio', etiquetas.WIZARD_DATOS_CREDENCIAL) === 'N' ? true : false : false ) && this.props.modifica === true){
            this.props.datosUsuario.tipoUsuario === "I" ? this.setState({habilitaSeccion: true}) : this.setState({habilitaSeccion: false});
            this.handleSecciones();
          }
      }
      
      /*.then(response => {
          this.setValueComponentWizard('encuentraOtroCorte', etiquetas.WIZARD_DATOS_CREDENCIAL, response.data.data);
      }).catch(error => {
          console.log("Error al onsultar corte actual de la sección", error);
      });*/
}


    render() {
      const {estado, proceso, datosUsuario } = this.props;
      const tipoUsuario = datosUsuario && datosUsuario.tipoUsuario ? datosUsuario.tipoUsuario : 'E';
      // Almacena el tamaño de las columnas de los componentes para usuario interno o externo
      const tamanioColumnas = tipoUsuario === 'I' ? 12 : 24;
      // Almacena el tamaño de la columna principal donde se agrupan los componentes (sección, sedes, convocatorias, clave elector, etc)
      const tamanioColumnasPrincipal = tipoUsuario === 'I' ? 24 : 12;

      // Obtenemos idEstado y idDistrito si hay datos de sesión del usuario
      const idEstado = estado ? estado.idEstado : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      const seccion = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] && this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].seccion ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].seccion.value : 0;
      const claveFUAR	= 	<Popover overlayClassName='pop_tooltip'
                                     disabled={this.state.modifica}
                            content={<img src={ayudaClaveFUAR} width='350px'/>}>
								<Icon type="info-circle" style={{ color: 'rgba(0,0,0,.45)' }} />
							</Popover>
      const soloSIAP = this.props.soloFuar || (this.state.modifica && this.props.datosUsuario && this.props.datosUsuario.tipoUsuario === 'E');
      const modificaSeccion = (!this.state.modifica || this.state.modifica) && this.state.habilitaSeccion && this.props.datosUsuario && this.props.datosUsuario.tipoUsuario === 'I';
      // Se definen textos para mostrar en aviso de privacidad
      const lstAviso = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] &&
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].objetoAvisos &&
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].objetoAvisos.lstAviso &&
            this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].objetoAvisos.lstAviso.length > 0 ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL].objetoAvisos.lstAviso : null;
      let tituloAviso = "Sin aviso de Privacidad Registrado", subtituloAviso = "", textoAviso = "", tituloDeclaro = "", urlAviso = "",urlAviso2="", arrayParrafoSinURL = "", textoAntesURL = "", textoDespuesURL = "",arrayParrafoSinURL2 = "", textoAntesURL2 = "", textoDespuesURL2 = "", textoDeclaro="", texto2Declaro= "";
      const parrafosTexto = [];   
      const parrafosTextoDeclaro = [];   
      if(lstAviso != null){
        tituloAviso     = lstAviso[etiquetas.TITULO_AVISO].descripcion;
        subtituloAviso  = lstAviso[etiquetas.SUBTITULO_AVISO].descripcion;
        textoAviso      = lstAviso[etiquetas.TEXTO_AVISO].descripcion;
        
        for (let i = etiquetas.TEXTO_AVISO; i < etiquetas.TITULO_DECLARO; i++) {
            if(lstAviso[i].descripcion.includes("http")){
              // Separamos URL del parráfo para dar formato en componente href
              urlAviso = obtenerURL(lstAviso[i].descripcion); 
              urlAviso2 = obtenerURL2(lstAviso[i].descripcion, urlAviso);
              
              arrayParrafoSinURL = lstAviso[i].descripcion.split(urlAviso);
              textoAntesURL   = arrayParrafoSinURL.length > 0 ? arrayParrafoSinURL[0] : "";
              textoDespuesURL = arrayParrafoSinURL.length > 1 ? arrayParrafoSinURL[1] : "";
              arrayParrafoSinURL2 = textoAntesURL.split(urlAviso2);
              textoAntesURL2 = arrayParrafoSinURL2.length > 0 ? arrayParrafoSinURL2[0]:"";
              textoDespuesURL2 = arrayParrafoSinURL2.length > 1 ? arrayParrafoSinURL2[1]:"";
              parrafosTexto.push(<p style={{'textAlign': 'justify'}}> {textoAntesURL2} <a href={urlAviso2} rel="noopener noreferrer" target="_blank">{urlAviso2}</a> {textoDespuesURL2} <a href={urlAviso} rel="noopener noreferrer" target="_blank"> {urlAviso} </a> {textoDespuesURL} </p>);
            }else{
              parrafosTexto.push(<p style={{'textAlign': 'justify'}}> {lstAviso[i].descripcion} </p>);
            }
        }

        tituloDeclaro   = lstAviso[etiquetas.TITULO_DECLARO].descripcion;  
        textoDeclaro     = lstAviso[etiquetas.INICIA_TEXTO_DECLARO].descripcion;
        texto2Declaro    = lstAviso[etiquetas.SEGUNDO_TEXTO_DECLARO].descripcion;
        parrafosTextoDeclaro.push(<p style={{'textAlign': 'justify'}}>{textoDeclaro}</p>)
        parrafosTextoDeclaro.push(<p style={{'textAlign': 'justify'}}>{texto2Declaro}</p>)
      } 
      return (
          <GoogleReCaptchaProvider
						reCaptchaKey={CAP_KEY}
						language="es-419" >

          <React.Fragment>
              <Modal
                className="modalError"
                title={<img  src={errorImgModal} id="img-error-modal"/>}
                centered
                onCancel={()=>this.cerrarErrorModal()}
                visible={this.state.abrirModalError}
                footer={false}
                width={400}
              >

                {this.state.msjError}
              </Modal>
              <div id="tvesModal" class="modalContainerCredencial">
                <div class="modal-content">
                <br/>
                <p>
                  Su nombre es:
                </p>
                <p>
                  <b>{this.state.nombre}</b>
                </p>
                <br/><br/>
                <p>
                  <Button class="close" onClick={this.cerrarModal}
                      style={{'marginRight':'15px'}}>
                    Si
                  </Button>
                  <Button class="close" onClick={this.habilitarCampos}>
                    NO
                  </Button>
                </p>
                </div>
              </div>
                <Card title={etiquetas.datos_credencial_lbl_titulo} bordered={false}>
                    <Row gutter={8}>
                      <Col sm={12} md={12} lg={12}
                          /* className={this.state.idEstado > 0 ? "disabledSeccion" : "enableSeccion"} */>

                            <Select nombre='idEstado'
                                    placeholder={etiquetas.datos_credencial_lbl_estado}
                                    form={this.props.form}
                                    required={true}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    rules={[{
                                            type: 'number'
                                        }]}
                                    showSearch={true}
                                    onChange={(value) => this.handleCmbEstado(value, 'idEstado')}
                                    selectedValue={this.state.idEstado}
                                    disabled={this.state.modifica || idEstado > 0}
                              >
                                    {
                                        this.state.lstEstados &&
                                        this.state.lstEstados.map((estado) => (
                                            <Option key={estado.idEstado} value={estado.idEstado}>
                                              {estado.nombreEstado}
                                            </Option>
                                        ))
                                    }
                            </Select>

                        </Col>
                      <Col sm={12} md={12} lg={12}>
                        <Select nombre='idDetalleProceso'
                                    placeholder={etiquetas.datos_credencial_lbl_proceso}
                                    form={this.props.form}
                                    onChange={(value) => this.handleCmbDetalleProceso(value, 'idDetalleProceso')}
                                    required={true}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    rules={[{
                                            type: 'number'
                                        }]}
                                    showSearch={true}
                                    selectedValue={this.state.idDetalleProceso}
                                    disabled={this.state.modifica || idDetalleProceso > 0 || this.state.idEstado === 0}
                                    >
                                    {
                                        this.state.lstProcesos &&
                                        this.state.lstProcesos.map((proceso) => (
                                            <Option key={proceso.idDetalleProceso} value={proceso.idDetalleProceso}>
                                              {proceso.descripcionDetalleLarga}
                                            </Option>
                                        ))
                                    }
                            </Select>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={tamanioColumnasPrincipal} md={tamanioColumnasPrincipal} lg={tamanioColumnasPrincipal}>
                        <Text style={{color: '#1890ff'}}>
                          <Icon type="info-circle" theme="filled"
                              style={{fontSize: '1.0em'}} />
                              Ingresa la sección correspondiente a la credencial de elector del aspirante.
                        </Text>
                      </Col>
                    </Row>
                  <Row>
                    <Col sm={tamanioColumnasPrincipal} md={tamanioColumnasPrincipal} lg={tamanioColumnasPrincipal}>
                        {/* Inicia columna de datos */}
                        <Row gutter={8}>
                            <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}
                              className={this.state.seccion > 0 || !this.state.puedeRegistrar ? "disabledSeccion" : "enableSeccion"}>
                              {!modificaSeccion ?
                                <InputText nombre={'seccion'}
                                  placeholder={etiquetas.datos_credencial_lbl_seccion}
                                  form={this.props.form}
                                  inputType='text'
                                  
                                  required={true}
                                  msjRequerido={etiquetas.general_dato_requerido}
                                  maxLength={4}
                                  //disabled
                                  rules={[{
                                            max: 4
                                            , pattern: /^\d{1,4}$/i
                                        }]}
                                        value={this.state.seccion}
                                  onBlur={this.props.datosUsuario === undefined && !mostrarCamposExtra ?
                                    (value) => this.handleTxtSeccionRegistroExterno(value, 'seccion') : 
                                    (value) => this.handleObtenrIdDtoSeccion(value)} 
                                    
                                  custom={{
                                        getValueFromEvent: (event, previo) => {
                                            if(etiquetas.REGEX_FORMATO_SOLO_DIGITOS.test(event.target.value)){
                                                return	event.target.value;
                                            }
                                            return previo;
                                        }
                                    }}
                                    validacionNegocio={!this.props.modifica}
                                    disabled={this.state.modifica && !this.state.habilitaSeccion || this.state.idDetalleProceso === 0}
                                  />
                                :<Select nombre='seccion'
                                        placeholder={etiquetas.datos_credencial_lbl_seccion}
                                        form={this.props.form}
                                        required={this.props.datosUsuario !== undefined ? true :false}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        
                                        onBlur={this.onChangeListaSecciones}
                                        rules={[{
                                                type: 'number'
                                            }]}
                                        showSearch={true}
                                        selectedValue={this.state.seccion}
                                        disabled={this.state.modifica && !this.state.habilitaSeccion && this.props.datosUsuario.tipoUsuario === "I"}
                                  >
                                  {
                                    this.state.lstSecciones &&
                                    this.state.lstSecciones.map((seccion, index) => (
                                        <Option key={index} value={seccion.seccion}>
                                          {seccion.seccion}
                                        </Option>
                                    ))
                                  }
                                </Select> }
                            </Col>

                            <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}
                            className={mostrarCamposExtra && tipoUsuario === 'I' ? "show" : "hide"}
                            >
                                
                                
                                <InputText nombre='nombreDttoCredencial'
                                    placeholder={"Distrito"}
                                    form={this.props.form}
                                    disabled={true}
                                    />
                            </Col>
                        </Row>
                        
                        <Row style={{'display': this.state.encuentraOtroCorte !== undefined ? 
                                                this.state.encuentraOtroCorte === true ? 'block' 
                                                :'none':'none', marginBottom: '1%'}}>
                          <Col >
                            <Text  style={{color: '#1890ff'}}>
                              <Icon type="info-circle" theme="filled"
                                  style={{fontSize: '1.0em'}} />
                                  {this.state.modifica !== undefined && this.state.modifica === false ? etiquetas.label_seccion_no_encontrada_registro : etiquetas.label_seccion_no_encontrada_modifica}
                                  <br/>
                            </Text>
                            
                          </Col>
                        </Row>
                        
                        <Row >
                          <Col 
                            className={mostrarCamposExtra && tipoUsuario === 'I' ? "show" : "hide"}>
                              <RadioGroup nombre={'participaOtroDttoRadio'}
                                        name={'participaOtroDttoRadio'}
                                        label={etiquetas.datos_credencial_lbl_otro_distrito}
                                        form={this.props.form}
                                        required={this.props.datosUsuario !== undefined ? true :false}
                                        disabled={this.state.habilitaOtroDtto !== undefined ? this.state.habilitaOtroDtto !== "" ? false: true  :true}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        onChange={(value) => this.handlerManejadorSN(value, 'participaOtroDttoRadio')}
                                        value={this.state.participaOtroDtto}
                                        rules={[{
                                                type: "enum"
                                                , enum: ['S', 'N']
                                            }]}>
                                {
                                    siNoOptions &&
                                    siNoOptions.map((opcion, index) => (
                                        <Radio key={index} value={opcion.value}>{opcion.label}</Radio>
                                    ))
                                }
                              </RadioGroup>
                          </Col>
                        </Row>
                        <Row gutter={8} className={mostrarCamposExtra && tipoUsuario === 'I' ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'] !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === "S" ? "show" : "hide" : "hide" : "hide" : "hide"}>
                          <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}
                            >
                              <Select nombre='idParticipacionDOM'
                                        placeholder={etiquetas.datos_credencial_lbl_otro_distrito_participar}
                                        form={this.props.form}
                                        required={this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'] !== undefined ? 
                                        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'S' ? true : false
                                        : false : false}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        
                                        onChange={this.onChangeDistritoParticipa}
                                        onBlur={this.lim}
                                        rules={[{
                                                type: 'number'
                                            }]}
                                        showSearch={true}
                                        selectedValue={this.state.seccion}
                                        disabled={this.state.modifica && !this.state.habilitaSeccion && this.props.datosUsuario.tipoUsuario === "I"}
                                  >
                                  {
                                    this.state.listaDistritos &&
                                    this.state.listaDistritos.map((listaDistritos, index) => (
                                        <Option key={index} value={listaDistritos.idDistrito}>
                                          {listaDistritos.idDistrito +" - "+listaDistritos.nombreDistrito}
                                        </Option>
                                    ))
                                  }
                                </Select>
                          </Col>
                          <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}
                            className={mostrarCamposExtra && tipoUsuario === 'I'}>
                              <Select nombre='idSeccionDOM'
                                        placeholder={etiquetas.datos_credencial_lbl_otra_seccion}
                                        form={this.props.form}
                                        required={this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL] !== undefined ? this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'] !== undefined ? 
                                        this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['participaOtroDttoRadio'].value === 'S' ? true : false
                                        : false :false}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        
                                        onChange={(value) => this.handleObtenerConvocatoriasNueva(value,'idSeccionDOM')}
                                        rules={[{
                                                type: 'number'
                                            }]}
                                        showSearch={true}
                                        selectedValue={this.state.idSeccionDOM}
                                        disabled={this.state.modifica && !this.state.habilitaSeccionOtro && this.props.datosUsuario.tipoUsuario === "I"}
                                  >
                                  {
                                    this.state.lstSecciones &&
                                    this.state.lstSecciones.map((seccion, index) => (
                                        <Option key={index} value={seccion.seccion}>
                                          {seccion.seccion}
                                        </Option>
                                    ))
                                  }
                                </Select>
                          </Col>
                        </Row>
                        <Row style={{'display': this.state.encuentraOtroCorteOtroDtto !== undefined  ? 
                                                this.state.encuentraOtroCorteOtroDtto === true  ? 'block' 
                                                :'none':'none', marginBottom: '1%'}}>
                          <Col >
                            <Text  style={{color: '#1890ff'}}>
                              <Icon type="info-circle" theme="filled"
                                  style={{fontSize: '1.0em'}} />
                                  {this.state.modifica !== undefined && this.state.modifica === false  ? etiquetas.label_seccion_no_encontrada_registro : etiquetas.label_seccion_no_encontrada_modifica}
                                  <br/>
                            </Text>
                            
                          </Col>
                        </Row>
                        <Row>
                          <Col 
                            className={mostrarCamposExtra && tipoUsuario === 'I' ? "show" : "hide"}
                            >
                                <Select nombre='idSedeReclutamientoJD'
                                        placeholder={etiquetas.datos_credencial_lbl_sede_reclutamiento}
                                        form={this.props.form}
                                        required={!this.state.disabledSedes}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        rules={[{
                                                type: 'number'
                                            }]}
                                        showSearch={true}
                                        selectedValue={this.state.idSede}
                                        disabled={this.state.disabledSedes }
                                        >
                                        {
                                            this.state.ltsSedes &&
                                            this.state.ltsSedes.map((sede, index) => (
                                                <Option key={index} value={sede.id}>
                                                  {sede.valor}
                                                </Option>
                                            ))
                                        }
                                </Select>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}
                              className={mostrarCamposExtra && tipoUsuario === 'I' ? "show" : "hide"}
                              id={this.state.sinConvocatoria !== "" ? "sinConvocatoria":"conConvocatoria"}>

                                <Select nombre='id_convocatoria'
                                        placeholder={etiquetas.datos_credencial_lbl_convocatoria}
                                        form={this.props.form}
                                        onChange={this.handleCmbConvocatoriaChange}
                                        required={this.props.datosUsuario !== undefined ? true :false}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        rules={[{
                                                type: 'number'
                                            }]}
                                        showSearch={true}
                                        selectedValue={this.state.idConvocatoria}
                                        disabled={this.state.modifica }
                                        >
                                        {
                                            this.state.ltsConvocatorias &&
                                            this.state.ltsConvocatorias.map((convocatoria, index) => (
                                                <Option key={index} value={convocatoria.idConvocatoria}>
                                                  <b>{convocatoria.numeroConvocatoria+" "}</b>
                                                  {"("+convocatoria.fechaRegistroInicio.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1')+" a "}
                                                  {convocatoria.fechaRegistroFin.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1')+")"}
                                                </Option>
                                            ))
                                        }
                                </Select>
                                <div className={this.state.sinConvocatoria !== ""
                                      ? "mostrarErrorFecha":"ocultarErrorFecha"}>
                                  {this.state.sinConvocatoria}
                                </div>
                            </Col>
                            <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas} style={{'marginTop':'5px'}}
                                className={mostrarCamposExtra && tipoUsuario === 'I' ? "show" : "hide"}
                                id={this.state.fechaFueraRango !== "" ? "campoIncorrecto":"campoCorrecto"}>

                                <Calendario nombre="fechaSolicitud"
                                    placeholder={etiquetas.datos_credencial_lbl_fechaRegistro}
                                    label={etiquetas.datos_credencial_lbl_fechaRegistro}
                                    required={this.props.datosUsuario !== undefined ? true :false}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    format={etiquetas.FORMATO_FECHA_MOMENT}
                                    formato="dd/mm/aaaa"
                                    showTime={false}
                                    showToday={true}
                                    form={this.props.form}
                                    onChange={this.handleObetenerInfoBlur}
                                    minDate="01/01/1900"
                                    maxDate={moment().format(etiquetas.FORMATO_FECHA_MOMENT)}
                                    disabled={this.state.modifica}

                                  />
                                  <br/>
                                  <div className={this.state.fechaFueraRango !== ""
                                        ? "mostrarErrorFecha":"ocultarErrorFecha"}>
                                    {this.state.fechaFueraRango}
                                  </div>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                        <Col >
                              <RadioGroup nombre={'cuentaCredencial'}
                                        name={'cuentaCredencial'}
                                        label={"¿Cuentas con credencial de elector física?"}
                                        form={this.props.form}
                                        required={true}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        onChange={(value) => this.handlerManejadorSNCredencial(value, 'cuentaCredencial')}
                                        value={this.state.cuentaCredencial}
                                        disabled={this.state.disableCuentaCredencial || (this.state.modifica && tipoUsuario !== 'I')}
                                        rules={[{
                                                type: "enum"
                                                , enum: ['S', 'N']
                                            }]}>
                                {
                                    siNoOptions &&
                                    siNoOptions.map((opcion, index) => (
                                        <Radio key={index} value={opcion.value}>{opcion.label}</Radio>
                                    ))
                                }
                              </RadioGroup>
                          </Col>
                        </Row>
                        <Row gutter={8} className={this.props.form.getFieldValue('cuentaCredencial') === undefined ? "hide" : "show"}> 
                            <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}>
                            <form autoComplete="off">
                                <InputText nombre='claveElectorFuar'
                                    onBlur={(value) => this.handleBlurClave(value, 'claveElectorFuar')}
                                    validacionNegocio={false}
                                    placeholder={this.props.form.getFieldValue('cuentaCredencial') === undefined ? '' : this.props.form.getFieldValue('cuentaCredencial') === 'S'? 'Clave de elector' : 'SIAP'}
                                    form={this.props.form}
                                    required={true}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    maxLength={18}
                                    disabled={soloSIAP || seccion === 0 || seccion === undefined || this.props.form.getFieldValue('cuentaCredencial') === undefined}
                                    rules={[{
                                              min: 13,
                                              max: 18,
                                              pattern: (this.props.form.getFieldValue('cuentaCredencial') === "S" ? etiquetas.REGEX_FORMATO_CLAVE_ELECTOR : etiquetas.REGEX_FORMATO_SIAP)
                                          }]}
                                    onPaste={(event) => {
                                      event.preventDefault();
                                    }} 
                                    custom={
                                      {
                                          getValueFromEvent: valueUpperCase
                                      }
                                    }/>
                                    </form>
                              </Col>

                            <Col sm={tamanioColumnas} md={tamanioColumnas} lg={tamanioColumnas}>
                              <form autoComplete="off">
                                  <InputText nombre='claveElectorFuarRepetir'
                                      onBlur={(value) => this.handleBlurClave(value, 'claveElectorFuarRepetir')}
                                      validacionNegocio={false}
                                      placeholder={this.props.form.getFieldValue('cuentaCredencial') === undefined ? '' : this.props.form.getFieldValue('cuentaCredencial') === 'S'? 'Confirmar tu Clave de elector' : 'Confirmar tu SIAP'}
                                      form={this.props.form}
                                      required={true}
                                      msjRequerido={etiquetas.general_dato_requerido}
                                      maxLength={18}
                                      disabled={soloSIAP || seccion === 0 || seccion === undefined || this.props.form.getFieldValue('cuentaCredencial') === undefined}
                                      
                                      rules={[{
                                                min: 13,
                                                max: 18,
                                                pattern: (this.state.modifica && this.state.claveElectorFuar.length > 13 ? etiquetas.REGEX_FORMATO_CLAVE_ELECTOR_FUAR_ANT : etiquetas.REGEX_FORMATO_CLAVE_ELECTOR_FUAR)
                                            }]}
                                      onPaste={(event) => {
                                        event.preventDefault();
                                      }} 
                                      custom={
                                        {
                                            getValueFromEvent: valueUpperCase
                                        }
                                      }/>
                                </form>
                            </Col>
                        </Row>
                    {/* Finaliza columna de datos */}
                    </Col>
                    <Col sm={tamanioColumnasPrincipal} md={tamanioColumnasPrincipal} lg={tamanioColumnasPrincipal} 
                      className={mostrarCamposExtra && tipoUsuario === 'I' ? "hide" : "show"}>
                        <div className='contenedor_animacion_ine_fuar'>
                          <img src={ animacionIneFuar} className='img_animacion_ine_fuar'
                            alt="Animación INE FUAR"/>
                        </div>
                    </Col>
                  </Row>
                  <br/>
                  <Row>
                      <Col sm={24} md={24} lg={24}>
                          <Checkbox nombre="avisoPrivacidad"
                                    form={this.props.form}
                                    required={true}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    rules={[{validator : (rule, value, cb) => (value === true ? cb() : cb(true))}]}
                                    style={{ 'textAlign': 'justify' }}
                                    disabled={this.state.modifica || this.state.deshabilitaAviso}
                                    onClick={()=>this.props.wizard.current.form.validateFields()}
                                    >
                              He leído el
                              <a disabled={this.state.modifica || this.state.deshabilitaAviso} href="#!" onClick={this.handleAvisoPrivacidadClick}> Aviso de Privacidad </a>
                              y otorgo mi consentimiento para que los datos personales sean tratados conforme al mismo.
                          </Checkbox>
                      </Col>
                  </Row>

                </Card>
                <Modal className="modalAvisoPrivacidad"
                    title={null}
                    footer={null}
                    centered={true}
                    visible={this.state.avisoPrivacidadVisible}
                    onOk={this.handleAvisoPrivacidadClose}
                    onCancel={this.handleAvisoPrivacidadClose}>
                    <Row gutter={16}>
                        <Col sm={12} md={12} lg={12}>
                            <div>
                                <h3 className="titulosAvisoPrivacidad" style={{ 'textAlign': 'center' }}> {tituloAviso} </h3> 
                                <h5 className="titulosAvisoPrivacidad" style={{ 'textAlign': 'center' }}> {subtituloAviso} </h5>
                                <p style={{'textAlign': 'justify'}}>
                                    { parrafosTexto }
                                </p>
                                {/*urlAviso.length !== 0 ? urlAviso : ''*/}
                              
                            </div>
                            
                        </Col>
                        <Col sm={12} md={12} lg={12}>
                        <div>
                            <h3 className="titulosAvisoPrivacidad" style={{ 'textAlign': 'center' }}> {tituloDeclaro} </h3> 
                            {parrafosTextoDeclaro}
                            </div>
                        </Col>
                    </Row>
                </Modal>
                <Modal title={null}
                       centered
                       visible={this.state.modalAbrir}
                       onOk={null}
                       onCancel={null}
                       closable={false}
                       footer={null}>
                    <div className='modal' style={{'fontSize': '16px' }}>
                        {this.state.mjs}
                    </div>
                    <br/><br/>
                    <div id="modal_botones">
                        <Button className="botonesModal" style={{width: 150}} onClick={this.habilitarCampos}> Aceptar </Button>
                    </div>
                </Modal>
          </React.Fragment>
          </GoogleReCaptchaProvider>

        );
    }
};

const mapStateToProps = createStructuredSelector({
  datosUsuario: selectCurrentUser,
  proceso: selectProceso,
  estado: selectEstado,
  distrito: selectDistrito,
  listaEstados: selectListaEstados,
  listaProcesos: selectListaProcesos,
  listaDistritos: selectListaDistritos
});

const mapDispatchToProps = dispatch => ({
	updateEstado: estado => dispatch(updateEstado(estado)),
	updateListaEstados: estados => dispatch(updateListaEstados(estados)),
	updateDetalle: detalle => dispatch(updateDetalle(detalle)),
	updateListaProcesos : (idEstado, procesos) => dispatch(updateListaProcesos(idEstado, procesos)),
  updateListaDistritos: (idDetalle, idEstado, distritos) => dispatch(updateListaDistritos(idDetalle, idEstado, distritos)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DatosCredencial);
